export default __webpack_public_path__ + "static/media/client-no-image.8859fba0.png";